<template>
    <div>
    <v-dialog
    v-model="dialog"
    max-width="35%"
    persistent

  >

  <v-form ref="new_mol" v-model="valid" @submit.prevent="" enctype="multipart/form-data" >
    <v-card>
<v-toolbar color="primary" dark>
                <v-toolbar-title>Новый товар</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="close_dialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

          <v-card-text>


              <!-- <v-text-field

                v-model="new_mol.nom"
                :rules="nomRules"
                label="Наименование"
                required
                class="m-2 p-0"

              ></v-text-field> -->
              <v-combobox
              v-model="new_mol.nom"
              :hide-no-data="!search"
              :items="molho"
              item-text="nom"
              :loading="loading"
              no-data-text="Новый товар"
              :search-input.sync="search"
              hide-selected
              solo
              label="Наименование"
              required
              class="m-2 p-0"
              :rules="nomRules1"

            >




        </v-combobox>


                <v-autocomplete
                    v-model="new_mol.category"
                    :items="categories"
                    label="Категория"
                    required
                    item-text="nom"
                    item-value="ID_KATEGORIA"
                    dense
                    clearable
                    :rules="selectRules"
                    hint="Выберите категорию товара"
                    no-data-text="Нет данных"
                    class="m-2 p-0"
                >
                </v-autocomplete>

                <v-row>
                    <v-col cols="12" md="8">
                        <v-text-field
                        class="m-2 p-0"
                            v-model="new_mol.minimum"
                            label="Минимальный остаток"
                            type="number"
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col>
                        <v-switch
                        class="m-0 p-0"
                        v-model="new_mol.srok_switch"
                        color="primary"


                    >
                    <template v-slot:label>
                        <span style="font-size: 15px">Срок годности</span>
                      </template>
                </v-switch>
                    </v-col> -->

                    <v-col>
                        <v-switch
                        class="m-0 p-0"
                        v-model="new_mol.imei_check"
                        color="primary"


                    >
                    <template v-slot:label>
                        <span style="font-size: 15px">IMEI</span>
                      </template>
                </v-switch>
                    </v-col>


                </v-row>



                <v-radio-group
                    class="m-2 p-0"
                    v-model="new_mol.type"
                    row
                    label="Тип товара"
                    color="primary"
                    :rules="selectRules"
                    required


                >
                    <v-radio
                        label="Штрихкод"
                        value="1"
                        @change="new_mol.baseCode = ''"
                    >
                    <template v-slot:label>
                        <v-card width="90" color="white" class="barcode d-flex align-center flex-column rounded-lg">
                        <v-icon class="mt-2" color="primary">mdi-barcode-scan</v-icon>
                        <small>Штрихкод</small>
                        </v-card>
                      </template>
                </v-radio>
                    <v-radio
                        label="Код"
                        value="2"
                        @click="get_last_code()"
                    >
                    <template v-slot:label>
                        <v-card width="50" color="white" class="code d-flex align-center flex-column rounded-lg">
                        <v-icon class="mt-2" color="primary">mdi-counter</v-icon>
                        <small>Код</small>
                        </v-card>
                      </template>
                    </v-radio>
                    <v-radio
                        label="Весы"
                        value="3"
                        @click="get_last_code()"
                    >
                    <template v-slot:label>
                        <v-card width="50" color="white" class="scale d-flex align-center flex-column rounded-lg">
                        <v-icon class="mt-2" color="primary">mdi-scale</v-icon>
                        <small>Весы</small>
                        </v-card>
                      </template>
                </v-radio>
                </v-radio-group>

                <!-- make field for base code -->
                <v-text-field v-if="new_mol.type !==null"
                class="m-2 p-0"
                    v-model="new_mol.baseCode"
                    :rules="baseCodeRules"
                    :label="new_mol.type === '1' ? 'Штрихкод' : new_mol.type === '2' ? 'Код' : 'Весы'"
                    required
                    :disabled="new_mol.type == 2 || new_mol.type == 3"
                    :autofocus="new_mol.type == 1"
                ></v-text-field>

                <!-- make field for child barcodes it can add more codes  -->
                <v-text-field v-if="new_mol.type == 1"
                    clearable
                    class="m-2 p-0"
                    v-model="childCode"
                    label="Дополнительные штрихкоды"
                    type="number"
                    :disabled="new_mol.type == 2 || new_mol.type == 3"
                    @keypress.enter="addChildCode"
                ></v-text-field>

                <!-- make list for showing child codes of product -->
                <v-list v-if="new_mol.type == 1" class="mt-0" >
                    <v-chip
                    class="m-1"
                    v-for="(item, i) in new_mol.childCodes" :key="i"
                    close
                    @click:close="removeChildCode(i)"
                    close-icon="mdi-delete"
                    color="blue"
                    outlined
                    >{{item}}</v-chip>
                </v-list>




              <v-text-field
              class="m-2 p-0"
                v-model="new_mol.description"
                label="Описание"
                clearable
              ></v-text-field>


              <v-file-input
                v-model="new_mol.image"
                show-size
                clearable
               class="m-0 p-0"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Загрузить изображение"
                prepend-icon="mdi-camera"
                label="Изображение"
                @change="onFileChange"
            ></v-file-input>


            <v-row >
                <v-col cols="4" >
                    <v-switch
                    class="m-0 p-0"
                    v-model="new_mol.shtuchniy_switch"
                    label="Штучный товар"
                    color="primary"
                    ></v-switch>

                </v-col>
                <v-col v-if="new_mol.shtuchniy_switch" cols="4">
                    <v-text-field
                        class="m-0 p-0"
                        v-model="new_mol.korobka"
                        :rules="sifrRules"
                        label="Количество в упаковке"
                        required
                        autofocus
                        ></v-text-field>

                </v-col>
                <v-col v-if="new_mol.shtuchniy_switch" cols="4">
                    <v-text-field
                    class="m-0 p-0"
                    v-model="new_mol.narkhi_dona"
                    :rules="sifrRules"
                    label="Цена за 1 шт"
                    required
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row  class="m-0 p-0">
                <v-col class="m-0 p-0" >
                    <v-switch
                    class="m-0 p-0"
                    v-model="strana_switch"
                    label="Страна"
                    color="primary"
                    ></v-switch>

                </v-col>
                <v-col cols="12"
                        sm="6"
                        md="8" v-if="strana_switch" class="m-0 p-0">
                    <v-autocomplete
                    v-model="new_mol.davlatt"
                    :items="davlat"
                    label="Страна"
                    required
                    item-text="nom"
                    item-value="id_davlat"
                    dense
                    clearable
                    :rules="selectRules"
                    hint="Выберите из списка или введите новую и нажмите Enter"
                    no-data-text="Нет данных"
                    @keypress.enter="addCountry"
                    class="m-0 p-0"
                ></v-autocomplete>
                </v-col>
            </v-row>





          </v-card-text>




      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="error darken-1"
          text
          @click="close_dialog"
        >
            Отмена
        </v-btn>

        <v-btn
          color="green darken-1"
          text
            @click="save_mol"
            :disabled="!valid"
            :loading="loading"

        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
</v-form>

    <v-snackbar
    v-model="snack"
    :timeout="3000"
    :color="snackColor"
  >
    {{ snackText }}

    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        text
        @click="snack = false"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>

  </v-dialog>

</div>
</template>

<script>
import axios from 'axios';

export default {
    data () {
      return {

        loading: false,

        strana_switch: false,
        valid: false,
        dialog: true,
        search:'',

        snack: false,
        snackColor: '',
        snackText: '',

        new_mol: {
            nom: '',
            category: 0,
            type: null,
            minimum: 0,
            srok_switch: false,
            baseCode: '',
            childCodes: [],
            description: '',
            shtuchniy_switch: false,
            image: null,
            korobka: 0,
            narkhi_dona: 0,
            davlatt: null,
            imei_check: false,



        },
        categories: [],
        davlat: [],
        molho: [],

        nomRules: [
            v => !!v || 'Название обязательно',
            v => (v && v.length <= 100) || 'Название должно быть меньше 100 символов',
            v => (v && v.length >= 3) || 'Название должно быть больше 3 символов',
        ],

        sifrRules: [
            // make sure the value is a number for price
            v => !!v || 'Значение обязательно',
            v => (v && v.length <= 10) || 'Значение должно быть меньше 10 символов',
            v => (v && v.length >= 1) || 'Значение должно быть больше 1 символов',
            v => (v && !isNaN(v)) || 'Значение должно быть числом',
            v=> (v && /[0-9]/.test(v)) || 'Неверный формат ввода',
            v => (v && /^\d*\.?\d*$/.test(v)) || 'Неверный формат ввода',
        ],

        baseCodeRules:[
            v => !!v || 'Значение обязательно',
            v => (v && /^\d*$/.test(v)) || 'Неверный формат ввода',

        ],

        selectRules: [
            v => !!v || 'Выберите значение из списка',

        ],
        nomRules1: [
            v => !!v || 'Введите наименование',

        ],

        // childCodes: [],

        childCode: '',
        rasm: null,


    }

},

mounted() {
    this.get_categories();
    this.get_davlat();
     this.get_molho();
},

methods: {

            get_categories(){
                        axios.get('/api/get_categories',
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    // this.snack = true
                                    // this.snackColor = 'success'
                                    // this.snackText = response.data.message
                                    this.categories = response.data.categories
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Ошибка получения категорий"

                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);

                                }

                            })
                            .catch(error => {
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });

            },
            get_davlat(){
                axios.get('/api/get_davlat',
                                {
                                    headers: {
                                        "Content-type": "application/json"
                                    }
                                })
                                .then(response => {
                                        if(response.data.status){
                                            // this.snack = true
                                            // this.snackColor = 'success'
                                            // this.snackText = response.data.message
                                            this.davlat = response.data.davlat
                                        setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                        }else{
                                            this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = "Ошибка получения стран"

                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);

                                        }

                                    })
                                    .catch(error => {
                                        this.snack = true
                                        this.snackColor = 'error'
                                        his.snackText = error.response.data.message;
                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                    });
            },

            get_molho(){
                axios.get('/api/molho_all',
                                {
                                    headers: {
                                        "Content-type": "application/json"
                                    }
                                })
                                .then(response => {
                                        if(response.data.status){
                                            this.molho = response.data.molho
                                        setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                        }else{
                                            this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = "Ошибка получения товар"

                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);

                                        }

                                    })
                                    .catch(error => {
                                        this.snack = true
                                        this.snackColor = 'error'
                                        this.snackText = error.response.data.message;
                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                    });
            },


            addChildCode(){
                if(this.childCode > 0){

                    axios.get('/api/check_child_code/'+ (this.childCode),

                                {
                                    headers: {
                                        "Content-type": "application/json"
                                    }
                                })
                                .then(response => {
                                        if(response.data.status){

                                            // if childCode  not equals in childCodes array
                                            if(this.new_mol.childCodes.indexOf(this.childCode) == -1 && this.childCode != this.new_mol.baseCode){
                                                this.new_mol.childCodes.push(this.childCode)
                                                this.childCode = ''
                                            }else{
                                                this.snack = true
                                                this.snackColor = 'error'
                                                this.snackText = "Такой код уже добавлен"
                                                this.childCode = ''
                                                setTimeout(() => {
                                                    this.snack = false;
                                                }, 2000);
                                            }

                                        setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                        }else{
                                            this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = "Такого кода не существует"

                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);

                                        }

                                    })
                                    .catch(error => {
                                        this.snack = true
                                        this.snackColor = 'error'
                                        this.snackText = error.response.data.message;
                                        this.childCode = ''
                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                            this.childCode = ''
                                    });

                }else{
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = "Введите правильный код"
                    this.childCode = ''
                    setTimeout(() => {
                        this.snack = false;
                    }, 2000);
                }





            },

            removeChildCode(index){
                this.new_mol.childCodes.splice(index, 1)
            },

            get_last_code(){
                axios.get('/api/get_last_code',
                                {
                                    headers: {
                                        "Content-type": "application/json"
                                    }
                                })
                                .then(response => {
                                        if(response.data.status){
                                            this.new_mol.baseCode = response.data.last_code
                                        setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                        }else{
                                            this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = "Ошибка получения последнего кода"

                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);

                                        }

                                    })
                                    .catch(error => {
                                        this.snack = true
                                        this.snackColor = 'error'
                                        this.snackText = error.response.data.message;
                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                    });

            },

            close_dialog(){
                this.dialog = false
                this.new_mol = {};
                this.$emit('update')

            },


            save_mol(){
                if(this.valid){
                    this.loading = true
                    const fd = new FormData();
                    fd.append('rasm', this.rasm);
                    fd.append('nom', this.new_mol.nom);
                    fd.append('category', this.new_mol.category);
                    fd.append('type', this.new_mol.type);
                    fd.append('minimum', this.new_mol.minimum);
                    fd.append('srok_switch', this.new_mol.srok_switch);
                    fd.append('imei_switch', this.new_mol.imei_check);
                    fd.append('baseCode', this.new_mol.baseCode);
                    fd.append('childCodes', this.new_mol.childCodes);
                    fd.append('description', this.new_mol.description);
                    fd.append('shtuchniy_switch', this.new_mol.shtuchniy_switch);
                    fd.append('korobka', this.new_mol.korobka);
                    fd.append('narkhi_dona', this.new_mol.narkhi_dona);
                    fd.append('davlatt', this.new_mol.davlatt);


                    axios.post('/api/save_mol', fd,
                                {
                                    headers: {
                                        // 'accept': 'multipart/form-data',
                                         'Content-Type': 'multipart/form-data',

                                        // 'Accept': 'application/json',
                                        // 'Access-Control-Allow-Origin': '*',
                                        //'Content-Type': 'application/json'
                                    }
                                })
                                .then(response => {
                                        if(response.data.status){
                                            this.snack = true
                                            this.snackColor = 'success'
                                            this.snackText = response.data.message
                                            this.$emit('update')
                                            this.$emit('id_mol', response.data.id_mol);
                                            this.loading = false;

                                          //  this.close_dialog();
                                           // this.get_mol()
                                           //console.log(response.data.message);
                                        setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                        }else{
                                            this.loading = false;
                                            this.snack = true
                                            this.snackColor = 'error'
                                            this.snackText = "Ошибка сохранения"

                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);

                                        }

                                    })
                                    .catch(error => {
                                        this.loading = false;
                                        this.snack = true
                                        this.snackColor = 'error'
                                        this.snackText = error.response.data.message;
                                            setTimeout(() => {
                                                this.snack = false;
                                            }, 2000);
                                    });
                }else{
                    this.loading = false;
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = "Заполните все поля"
                    setTimeout(() => {
                        this.snack = false;
                    }, 2000);
                }


            },

            onFileChange(event){
             //   console.log(event);
                this.rasm = event;
              //  console.log(this.rasm);

            },










},

}

</script>

<style>

</style>




